import React from 'react'
import { AllRightsReserved, SMTechnoConsultantsPvtLtd } from '../../Data/Constant'

const Footer = () => {
    return (
        <footer className="content-footer footer bg-footer-theme">
            <div className="container-fluid">
                <div className="footer-container d-flex  align-items-center py-4 flex-md-row flex-column">
                    <div className="text-body">
                        <a href="https://smtechno.com/" target="_blank" className="footer-link">{SMTechnoConsultantsPvtLtd}&nbsp;&nbsp;    </a>
                    </div>
                    <div className="d-none d-lg-inline-block">
                        {AllRightsReserved}
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
